import type { IAppNavigationMenuItem } from '../components.interfaces';
import { isNavItemActive } from './navigationDrawer.pathUtils';

export type SubmenuOpenState = Record<string, boolean>;

/** Expand parents whose route prefix matches the current URL (so sub-items stay visible). */
export function buildSubmenuExpandedFromRoute(
  items: IAppNavigationMenuItem[],
  parentRoute: string,
  pathname: string,
  selectedPage: string
): SubmenuOpenState {
  const acc: SubmenuOpenState = {};
  const walk = (list: IAppNavigationMenuItem[], pr: string) => {
    list.forEach((item) => {
      if (!item.subPages) return;
      const fullPath = pr + item.pageToNavigate;
      acc[item.pageToNavigate] =
        item.pageToNavigate === selectedPage ||
        isNavItemActive(pathname, fullPath);
      walk(item.subPages, fullPath);
    });
  };
  walk(items, parentRoute);
  return acc;
}

/**
 * Toggle one section; keep sections "route-locked" (current URL under that branch) expanded;
 * collapse others unless they contain the active route.
 */
export function computeSubmenuToggleState(
  items: IAppNavigationMenuItem[],
  parentRoute: string,
  pathname: string,
  pageToNavigate: string,
  isAlreadyExpanded: boolean
): SubmenuOpenState {
  const next: SubmenuOpenState = {};
  const walk = (list: IAppNavigationMenuItem[], pr: string) => {
    list.forEach((item) => {
      if (!item.subPages) return;
      const fullPath = pr + item.pageToNavigate;
      const routeLock = isNavItemActive(pathname, fullPath);
      if (item.pageToNavigate === pageToNavigate) {
        const toggled = isAlreadyExpanded ? false : true;
        next[item.pageToNavigate] = routeLock ? true : toggled;
      } else {
        next[item.pageToNavigate] = routeLock ? true : false;
      }
      walk(item.subPages, fullPath);
    });
  };
  walk(items, parentRoute);
  return next;
}
